/**
 * Copy the parent inner text when clicking on the copy button
 * 
 * Usage:
 * <code class="copy">
 *      Text to copy
 *      <button type="button" title="{{ 'Copy'|trans }}" class="copy js-copy-btn">
 *          {{ get_svg('ico-copy') }}
 *          <span class="tooltip">{{ 'Copied to clipboard'|trans }}</span>
 *      </button>
 * </code>
 * 
 * TODO: Remplacer la tooltip par tippy.js
 * 
 * @return {void}
 */
export default function initCopyInClipboardButtons() : void {
    document.querySelectorAll<HTMLButtonElement>('.js-copy-btn').forEach($btn => {
        const $tooltip = $btn.querySelector('.tooltip') as HTMLElement;

        // Copy the text in parent element and show the tooltip for 1.5s
        let timeout: ReturnType<typeof setTimeout> = 0;
        $btn.addEventListener('click', () => {
            // Get the text in parent element and remove the button innerText from it
            const btnText = $btn.innerText;
            const text = ($btn.parentElement as HTMLElement).innerText.replace(btnText, '').trim();

            navigator.clipboard.writeText(text);

            $tooltip.classList.add('show');

            clearTimeout(timeout);
            timeout = setTimeout(() => {
                $tooltip.classList.remove('show');
            }, 1500);
        });
    });
}
